import React from 'react'
import {Button, Form} from 'antd'

import FormContext from 'components/Form/FormContext'

const FormHandler = ({submitCallback, submitTitle, AdditionalButtons, children}) => {
  const [loading, setLoading] = React.useState(false)
  const form = React.useContext(FormContext)

  const onSubmit = e => {
    e.preventDefault()
    form.validateFields((err, values) => {
      if (!err && submitCallback) {
        setLoading(true)
        submitCallback(values, setLoading)
      }
    })
  }

  return (
    <Form>
      {children}

      <Button type='primary' htmlType='submit' onClick={onSubmit} loading={loading}
              style={{marginRight: AdditionalButtons ? '1.5em' : 0}}>
        {submitTitle ? submitTitle : 'Submit'}
      </Button>
      {AdditionalButtons}
    </Form>
  )
}

export default FormHandler
